import { useTheme as useThemeReact } from "@bpipartners/webui";
import { createTheme } from "@bpipartners/webui";
import { dimensions } from "./dimensions";

import { appColors, appPalette } from "./scev.colors";

// ------------------------------------------------------------------------------

export const getSCEVTheme = () => {
  const palette = appPalette;
  const materialTheme = createTheme({
    spacing: 4,
    components: {
      MuiTextField: {
        defaultProps: { variant: "filled" },
      },
      MuiDatePicker: {
        defaultProps: { slotProps: { textField: { variant: "filled" } } },
      },
      MuiDateTimePicker: {
        defaultProps: {
          slotProps: { textField: { variant: "filled" } },
        },
      },
      MuiDateRangePicker: {
        defaultProps: { slotProps: { textField: { variant: "filled" } } },
      },
      MuiPaper: {
        defaultProps: {
          variant: "outlined",
        },
        styleOverrides: {
          root: {
            // borderRadius: 12,
            padding: 0,
            paddingTop: 8,
            paddingBottom: 8,
            // backgroundColor: appColors.surfaceContainerLowest,
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            borderRadius: 0,
          },
        },
      },
      MuiButton: {
        defaultProps: {
          size: "medium",
        },
        styleOverrides: {
          root: {
            borderRadius: 24,
            height: 36,
            textTransform: "none",
            // background: colors.appColors.tertiary,
          },
        },
      },
      MuiSelect: {
        defaultProps: {
          variant: "filled",
        },
        styleOverrides: {
          root: {
            // background: appColors.surfaceContainerLow,
            "&.Mui-disabled": {
              background: appColors.surfaceContainerLow,
              color: "#dadada",
            },
          },
        },
      },
    },
    palette: {
      DataGrid: {
        headerBg: appPalette.secondary[80],
        pinnedBg: appPalette.secondary[80],
      },

      // type: "light",
      background: {
        default: appPalette.neutral[100],
        paper: appColors.surfaceContainerLowest,
      },
      primary: {
        light: appPalette.primary[80],
        main: appPalette.primary[60],
        dark: appPalette.primary[30],
        contrastText: appColors.onPrimary,
      },
      secondary: {
        light: appPalette.secondary[60],
        main: appColors.secondary,
        dark: appPalette.secondary[30],
        contrastText: appColors.onSecondary,
      },
    },
  });
  return {
    ...materialTheme,
    // Override material default: show header above drawer (sidebar)
    zIndex: {
      ...materialTheme.zIndex,
      appBar: materialTheme.zIndex.drawer,
      drawer: materialTheme.zIndex.appBar,
    },
    appColors: appColors,
    appPalette: appPalette,
    dimensions,
  };
};

type Theme = ReturnType<typeof getSCEVTheme>;

export const useScevTheme = () => useThemeReact() as Theme;
